import { TK } from "./translationKeys"

declare var i18nData: Record<TK, string> | undefined
declare var language: string | undefined

export interface Translate<KeyType> {
    (key: KeyType, ...injectables: string[]): string
}

const strFormat = (source: string, params: string[]) =>
    params.reduce((prev, curr, idx) => prev.replace(new RegExp("\\{" + idx + "\\}", "g"), curr), source);

export const i18nReady = () => typeof language !== 'undefined' && typeof i18nData !== 'undefined'

export const getLanguage = (): 'en'|'pt'|'fr' => {
    return language === 'pt' || language === 'en' || language === 'fr' ? language : 'pt'
}

export const translate = (key: TK, ...injectables: string[]) => {
    if (typeof i18nData === 'undefined') return key
    return injectables.length && i18nData
        ? strFormat(i18nData[key], injectables)
        : i18nData?.[key] || key;
}
     

export const useTranslations = (): Translate<TK> => translate
